import "./calculator.scss";
import { Drawer } from "@mui/material";
import { useState } from "react";
import { BrandButton } from "./buttons";
import { imagesUrl } from "../utils";

const Calculator = () => {
  const [calcOpen, setCalOpen] = useState(false);

  return (
    <div className="calculator">
      <div className="calButton" onClick={() => setCalOpen(true)}>
        <img src={`${imagesUrl}/calculator.svg`} alt="calculator" />
      </div>
      <Drawer anchor="right" open={calcOpen} onClose={() => setCalOpen(false)}>
        <div className="drawerContents">
          <BrandButton onClick={() => setCalOpen(false)}>CLOSE</BrandButton>
          <div>
            <iframe
              src="https://www.desmos.com/calculator"
              width="100%"
              height="600"
              frameBorder="0"
              title="calculator"
            ></iframe>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default Calculator;
